import { useEffect, useState } from "react";
import { loadAnalytics, saveAnalytics } from "./adminApi";

function AdminAnalytics() {
  const [measurementId, setMeasurementId] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    async function fetchId() {
      try {
        const res = await loadAnalytics();
        setMeasurementId(res.measurement_id || "");
      } catch (err) {
        setError(err.message || "Unable to load analytics settings.");
      }
    }
    fetchId();
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setIsSaving(true);
    try {
      const res = await saveAnalytics({ measurement_id: measurementId.trim() });
      setMessage(res.message || "Saved.");
        // notify other parts of the app to reload GA settings immediately
        try { window.dispatchEvent(new Event('site:ga-updated')); } catch (e) {}
    } catch (err) {
      setError(err.message || "Unable to save.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <div>
          <p className="eyebrow">Analytics</p>
          <h2>Google Analytics (GA4)</h2>
          <p className="admin-page-note">Enter GA Measurement ID (G-XXXXXXXXXX). Leave blank to disable tracking.</p>
        </div>
      </div>

      {error && <p className="auth-error">{error}</p>}
      {message && <p className="admin-success-message">{message}</p>}

      <form className="admin-form" onSubmit={handleSave}>
        <div className="panel-block">
          <label htmlFor="gaId">Measurement ID</label>
          <input
            id="gaId"
            type="text"
            value={measurementId}
            onChange={(e) => setMeasurementId(e.target.value)}
            placeholder="G-XXXXXXXXXX"
          />
        </div>

        <div className="add-blog-actions">
          <button type="submit" className="admin-button primary" disabled={isSaving}>
            {isSaving ? "Saving..." : "Save"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default AdminAnalytics;
